<template>
  <div class="reset-password" v-loading="loading">
    <div class="reset-password-container">
      <el-form>
        <el-form-item label="Новый пароль">
          <el-input type="password" v-model="form.password" placeholder="Введите новый пароль"/>
        </el-form-item>
        <el-form-item label="Повторите пароль">
          <el-input type="password" v-model="form.confirmPassword" placeholder="Повторите новый пароль"/>
        </el-form-item>
        <el-button type="primary" @click="reset">Сохранить</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'ResetPassword',

  data() {
    return {
      form: {
        password: '',
        confirmPassword: '',
      },
      loading: false,
    };
  },

  methods: {
    reset() {
      if (this.form.password.length < 6) {
        this.$notify.error({
          title: 'Ошибка', offset: 60,
          message: 'Пароль должен быть более 6 символов',
        });
      } else if (this.form.password !== this.form.confirmPassword) {
        this.$notify.error({
          title: 'Ошибка', offset: 60,
          message: 'Пароли не совпадают',
        });
      } else {
        this.loading = true;
        firebase.auth().confirmPasswordReset(this.$route.params.code, this.form.password).then((response) => {
          this.$notify.success({
            title: 'Успешно', offset: 60,
            message: 'Пароль успешно изменен',
          });
          this.$router.push(`/`);
        }).catch((error) => {
          this.loading = false;
          this.$notify.error({
            title: 'Ошибка', offset: 60,
            message: error,
          });
        });
      }

    },
  },
};
</script>

<style scoped lang="scss">
.reset-password {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
}

.reset-password-container {
  max-width: 382px;
  width: calc(100% - 40px);

  button {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Authorization/ResetPassword.vue